import { star } from 'ionicons/icons'

export class ValueRange {
    start: number
    end: number
    
    constructor(start: number, end: number) {
        this.start = start
        this.end = end
    }
}